<main class="recovery-page">
  <section class="brand-panel" aria-label="DeskPlus One">
    <a class="brand" routerLink="/login">
      <span class="brand-mark" aria-hidden="true">D+</span>
      <span>DeskPlus One</span>
    </a>

    <div class="brand-copy">
      <p class="eyebrow">PROTECCION DE CUENTA</p>
      <h1>Crea una nueva contrasena.</h1>
      <p>
        Tu nueva contrasena protege el acceso a todos los servicios
        autorizados para tu identidad en DeskPlus One.
      </p>
    </div>

    <p class="brand-footer">NIOTECH SOLUTIONS</p>
  </section>

  <section class="form-panel">
    <div class="form-shell">
      @if (completed()) {
        <header class="form-heading">
          <p class="eyebrow">CONTRASENA ACTUALIZADA</p>
          <h2>Tu acceso esta listo</h2>
          <p>
            La nueva contrasena fue establecida correctamente.
            Ya puedes iniciar sesion.
          </p>
        </header>

        <div class="notice notice--success" role="status">
          <span class="notice-mark" aria-hidden="true">&#10003;</span>
          <span>El enlace de recuperacion ya no puede volver a utilizarse.</span>
        </div>

        <a class="back-link" routerLink="/login">
          Ir a iniciar sesion
          <span aria-hidden="true">&rarr;</span>
        </a>
      } @else {
        <header class="form-heading">
          <p class="eyebrow">NUEVA CONTRASENA</p>
          <h2>Protege tu cuenta</h2>
          <p>
            Elige una contrasena que no utilices en otros servicios.
          </p>
        </header>

        @if (!token) {
          <div class="notice notice--error" role="alert">
            <span class="notice-mark" aria-hidden="true">!</span>
            <span>
              Este enlace no contiene un token de recuperacion valido.
              Solicita un nuevo enlace.
            </span>
          </div>

          <a class="back-link" routerLink="/forgot-password">
            Solicitar un nuevo enlace
            <span aria-hidden="true">&rarr;</span>
          </a>
        } @else {
          @if (errorMessage()) {
            <div class="notice notice--error" role="alert">
              <span class="notice-mark" aria-hidden="true">!</span>
              <span>{{ errorMessage() }}</span>
            </div>
          }

          <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
            <div class="field">
              <label for="newPassword">Nueva contrasena</label>
              <div class="password-wrap">
                <input
                  id="newPassword"
                  [type]="showPassword() ? 'text' : 'password'"
                  formControlName="newPassword"
                  autocomplete="new-password"
                  placeholder="Minimo 12 caracteres"
                />
                <button
                  class="show-password"
                  type="button"
                  (click)="togglePassword()"
                >
                  {{ showPassword() ? 'Ocultar' : 'Ver' }}
                </button>
              </div>

              <p class="password-hint">
                Minimo 12 caracteres. No exigimos reglas arbitrarias de simbolos
                o mayusculas.
              </p>

              @if (
                form.controls.newPassword.touched &&
                form.controls.newPassword.invalid
              ) {
                <p class="field-error">
                  La contrasena debe tener entre 12 y 128 caracteres.
                </p>
              }
            </div>

            <div class="field">
              <label for="confirmPassword">Confirmar contrasena</label>
              <input
                id="confirmPassword"
                [type]="showPassword() ? 'text' : 'password'"
                formControlName="confirmPassword"
                autocomplete="new-password"
                placeholder="Repite la nueva contrasena"
              />

              @if (
                form.controls.confirmPassword.touched &&
                form.hasError('passwordMismatch')
              ) {
                <p class="field-error">Las contrasenas no coinciden.</p>
              }
            </div>

            <button class="primary-action" type="submit" [disabled]="loading()">
              @if (loading()) {
                <span class="spinner" aria-hidden="true"></span>
                Actualizando...
              } @else {
                Guardar nueva contrasena
                <span aria-hidden="true">&rarr;</span>
              }
            </button>
          </form>
        }
      }
    </div>
  </section>
</main>